import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import UI from "source/app/services/UI/UI";

export function DreamsScrollIcon({
    direction,
    disabled,
}: {
    direction: "up" | "down";
    disabled: boolean;
}) {
    const isUp = direction === "up";

    return (
            <IconWithText
                iconSuffix={EGlyphicon[isUp ? "arrow-up" : "arrow-down"]}
                whenClicked={() =>
                    !disabled &&
                    (isUp
                        ? UI.ScrollToFirst("[data-dream-row]")
                        : UI.ScrollToLast("[data-dream-row]"))
                }
                displayAsBlock={false}
            />
    );
}
